import React from "react";
import EditContainer from "../EditContainer";
import { PAGES } from "../../../util/constants/pages";

export const CashClaimApprovalEditContainer = () => (
  <EditContainer page={PAGES.CASH_CLAIM_APPROVAL} />
);
